import React from 'react';
import { Col, Image, Row, Stack } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import SearchIcon from 'assets/images/Dashboard/search-detail.svg';
import DocumentIcon from 'assets/images/Dashboard/document.svg';
import DownloadIcon from 'assets/images/Dashboard/download-light.svg';
import EmptyScreen from 'assets/images/Dashboard/empty.svg';
import moment from 'moment';

const AppointmentTab = () => {
  const aboutData = useSelector(
    (state) => state?.providerDetailReducer?.users?.data
  );
  return (
    <div>
      {aboutData?.appointment_history &&
      aboutData?.appointment_history.length > 0 ? (
        <div className="pt-16">
          <Row className="m-0">
            <Col sm={12} md={6} className="p-0">
              <div className="border-b border-detail-gray listCustomHeader">
                <Row className="m-0 p-10 ">
                  <Col md={4} className="p-0">
                    <div className="fs-14 fc-202224 lh-176 family_outfit_semiBold_600">
                      Consultation mode
                    </div>
                  </Col>
                  <Col md={4} className="p-0">
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center"
                    >
                      <div>
                        <Image src={SearchIcon} alt="icon" />
                      </div>
                      <div className="fs-14 fc-202224 lh-176 family_outfit_semiBold_600">
                        Booking ID
                      </div>
                    </Stack>
                  </Col>
                  <Col md={4} className="p-0">
                    <div className="fs-14 fc-202224 lh-176 family_outfit_semiBold_600">
                      Date & Time
                    </div>
                  </Col>
                </Row>
              </div>
              {aboutData?.appointment_history.map((item, index) => {
                return (
                  <div className="listCustomHeader">
                    <Row className="bc-FFFFFF m-0 p-0">
                      <Row className="m-0 p-10">
                        <Col md={4} className="p-0">
                          <div className="fs-14 fc-202224 lh-176 family_outfit_regular_400 py-12">
                            {item?.consultation_type}
                          </div>
                        </Col>
                        <Col md={4} className="p-0">
                          <div className="fs-14 fc-202224 lh-176 family_outfit_regular_400 py-12">
                            {item?.booking_id}
                          </div>
                        </Col>
                        <Col md={4} className="p-0">
                          <div className="fs-14 fc-202224 lh-176 family_outfit_regular_400">
                            {moment(item?.appointment_date_time).format(
                              'DD MMM YYYY'
                            )}
                            <br />
                            <span className="fs-14 fc-202224 lh-176 family_outfit_regular_400">
                              {moment(item?.appointment_date_time).format(
                                'hh:mmA'
                              )}
                            </span>
                          </div>
                        </Col>
                      </Row>
                    </Row>
                  </div>
                );
              })}
            </Col>
            <Col sm={12} md={6}>
              <div className="border-b border-detail-gray listCustomHeader">
                <Row className="m-0 px-16 py-10">
                  <Col md={12} className="p-0">
                    <Stack
                      direction="horizontal"
                      gap={2}
                      className="items-center"
                    >
                      <div>
                        <Image src={SearchIcon} alt="icon" />
                      </div>
                      <div className="fs-16 fc-202224 lh-16 family_outfit_medium_500">
                        Medical Records
                      </div>
                    </Stack>
                  </Col>
                </Row>
              </div>
              {aboutData?.appointment_history.map((item, index) => {
                return (
                  <div className="listCustomHeader">
                    <Row className="bc-FFFFFF m-0 px-16 py-10">
                      <Row className="m-0 p-0">
                        <Col md={12} className="p-0">
                          <Stack
                            direction="horizontal"
                            className="flex justify-between"
                          >
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center"
                            >
                              <div>
                                <Image src={DocumentIcon} alt="icon" />
                              </div>
                              <div className="fs-14 fc-202224 lh-176 family_outfit_regular_400">
                                <a
                                  href={item?.diagnosis_report || '#'}
                                  download={
                                    item?.diagnosis_report
                                      ? item?.diagnosis_report.split('/').pop()
                                      : 'license'
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="fs-14 fc-202224 lh-176 family_outfit_regular_400 cursor-pointer underline underline-offset-4"
                                >
                                  {item?.diagnosis_report &&
                                    item?.diagnosis_report.split('/').pop()}
                                </a>
                              </div>
                            </Stack>
                            <Stack
                              direction="horizontal"
                              gap={2}
                              className="items-center"
                            >
                              <div>
                                <a
                                  href={item?.diagnosis_report || '#'}
                                  download={
                                    item?.diagnosis_report
                                      ? item?.diagnosis_report.split('/').pop()
                                      : 'license'
                                  }
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="fs-14 fc-202224 lh-176 family_outfit_regular_400 cursor-pointer underline underline-offset-4"
                                >
                                  <Image src={DownloadIcon} alt="icon" />
                                </a>
                              </div>
                            </Stack>
                          </Stack>
                        </Col>
                      </Row>
                    </Row>
                  </div>
                );
              })}
            </Col>
          </Row>
        </div>
      ) : (
        <div className="flex justify-center pt-80">
          <div>
            <Image src={EmptyScreen} alt="icon" />
            <div className="fs-20 fc-3C3C3C lh-2 family_outfit_medium_500 text-center pt-30">
              Nothing here yet
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AppointmentTab;
